import { render, staticRenderFns } from "./DashboardPanel.vue?vue&type=template&id=03f4baf2&scoped=true&"
import script from "./DashboardPanel.vue?vue&type=script&lang=js&"
export * from "./DashboardPanel.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPanel.vue?vue&type=style&index=0&id=03f4baf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f4baf2",
  null
  
)

export default component.exports